import {
  SHOW_CREATE_NEW_BROADCAST,
  SET_BROADCAST_WHATSAPP_LIST,
  SHOW_BROADCAST_CONTACT_LIST,
  SHOW_BROADCAST_CANCEL_DIALOG,
  SHOW_BROADCAST_WHATSAPP_TEMPLATE_DIALOG,
  REMOVE_BROADCAST_FROM_LIST,
  ADD_BROADCAST,
  UPDATE_BROADCAST_STATUS,
  SET_BROADCAST_WHATSAPP_TEMPLATE_MESSAGE,
  SET_BROADCAST_CONTACTS_SELECTED,
} from '@/store/mutation-types';
import {
  getBroadcastWhatsAppList,
  cancelBroadcastWhatsApp,
  newBroadcastWhatsApp,
} from '@/services/broadcast-service';
import ContactService from '@/services/contact-service';
import WhatsAppService from '@/services/whatsapp-service';

const actions = {
  openDialogCreateNewBroadcast({ commit }) {
    commit(SHOW_CREATE_NEW_BROADCAST, true);
  },
  closeDialogCreateNewBroadcast({ commit }) {
    commit(SHOW_CREATE_NEW_BROADCAST, false);
  },
  setBroadcastContactsSelected({ commit }, contacts) {
    commit(SET_BROADCAST_CONTACTS_SELECTED, contacts);
  },
  getBroadcastWhatsAppList({ commit, rootState }) {
    const agentId = rootState.attendance.Attendance.agentId;
    getBroadcastWhatsAppList(agentId).then((list) => {
      commit(SET_BROADCAST_WHATSAPP_LIST, list);
    });
  },
  openBroadcastContactListDialog({ commit }, broadcastListId) {
    commit(SHOW_BROADCAST_CONTACT_LIST, broadcastListId);
  },
  closeBroadcastContactListDialog({ commit }) {
    commit(SHOW_BROADCAST_CONTACT_LIST, null);
  },
  openBroadcastCancelDialog({ commit }, broadcastListId) {
    commit(SHOW_BROADCAST_CANCEL_DIALOG, broadcastListId);
  },
  closeBroadcastCancelDialog({ commit }) {
    commit(SHOW_BROADCAST_CANCEL_DIALOG, null);
  },
  openBroadcastWhatsAppTemplateDialog({ commit }) {
    commit(SHOW_BROADCAST_WHATSAPP_TEMPLATE_DIALOG, true);
  },
  closeBroadcastWhatsAppTemplateDialog({ commit }) {
    commit(SHOW_BROADCAST_WHATSAPP_TEMPLATE_DIALOG, false);
  },
  cancelBroadcastWhatsApp({ commit, dispatch, rootState }, broadcastListId) {
    const agentId = rootState.attendance.Attendance.agentId;
    const params = {
      agentId: agentId.toString(),
      whatsAppBroadcastId: broadcastListId,
    };

    cancelBroadcastWhatsApp(params).then((response) => {
      commit(SHOW_BROADCAST_CANCEL_DIALOG, null);
      commit(REMOVE_BROADCAST_FROM_LIST, response.body.whatsAppBroadcastId);
      dispatch(
        'showSnackbar',
        { text: 'broadcast.cancel.toastSuccess', type: 'success' },
        { root: true },
      );
    });
  },
  searchAgentPreferentialContacts({ rootState }, term) {
    const agentId = rootState.attendance.Attendance.agentId;
    const params = { agent: agentId.toString(), name: term, broadcast: false };

    return ContactService.search(params).then((contacts) => {
      const contactsFound = contacts.data;

      let contactsFoundNormalized = [];
      contactsFound.forEach((contact) => {
        contactsFoundNormalized.push({
          contactName: contact.fullname,
          contactIdentifier: contact.identifier,
          contactId: contact.id,
          contactWhatsAppIdentifier: contact.whatsapp_identifier,
        });
      });
      return contactsFoundNormalized;
    });
  },
  getBroadcastTemplateWhatsAppList({ rootState }, routeId) {
    const orgUnitId = rootState.attendance.orgUnitInformation.id;
    return WhatsAppService.getGupshupWhatsappTemplatesMessages(
      orgUnitId,
      routeId,
    ).then((templates) => {
      const templateList = templates.data;

      let templateListNormalized = [];
      templateList.forEach((template) => {
        templateListNormalized.push({
          templateId: template.preset_message_id,
          templateName: template.preset_message_name,
          templateMessage: template.preset_message_description,
          templateType: template.preset_message_template_type,
        });
      });
      return templateListNormalized;
    });
  },
  async newBroadcastWhatsApp(
    { commit, dispatch, rootState },
    newBroadcastInformation,
  ) {
    const agentId = rootState.attendance.Attendance.agentId;
    newBroadcastInformation.agentId = agentId.toString();

    return await newBroadcastWhatsApp(newBroadcastInformation).then(
      (response) => {
        commit(ADD_BROADCAST, response.body.broadcast);
        dispatch(
          'showSnackbar',
          { text: 'broadcast.new.toastSuccess', type: 'success' },
          { root: true },
        );

        return true;
      },
    );
  },
  updateBroadcastWhatsAppStatus({ commit }, broadcastInformation) {
    commit(UPDATE_BROADCAST_STATUS, broadcastInformation);
  },
  setBroadcastTemplateSelected({ commit }, template) {
    commit(SET_BROADCAST_WHATSAPP_TEMPLATE_MESSAGE, template);
  },
};

export default actions;
